const rightHand = [
  "https://face-image.sduonline.cn/621f3efc9fc00000.png", // ../assets/01右手/you1.png
  "https://face-image.sduonline.cn/621f3efcc3400000.png", // ../assets/01右手/you2.png
  "https://face-image.sduonline.cn/621f3efcc3800000.png", // ../assets/01右手/you3.png
  "https://face-image.sduonline.cn/621f3efcc2400000.png", // ../assets/01右手/you4.png
  "https://face-image.sduonline.cn/621f3efcc3800001.png", // ../assets/01右手/you5.png
];
const bigRightHand = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/212414/39/30978/1774/647a1ba5F04c5fee8/25aac4f4dafce89d.jpg", // ../assets/缩略图/01右手/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/130327/27/38016/3362/647a1ba5F777324d9/3610d7d8b9a9b719.jpg", // ../assets/缩略图/01右手/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/216018/20/29857/3623/647a1ba5Ff57c9264/a37928b16cd515d0.jpg", // ../assets/缩略图/01右手/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/42077/12/20643/1740/647a1ba5Ff6c1eeed/10f959c82fe22327.jpg", // ../assets/缩略图/01右手/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/170084/22/34528/2453/647a1ba5F78af70c7/20c568c585255b34.jpg", // ../assets/缩略图/01右手/5.png
];
const leftHand = [
  "https://face-image.sduonline.cn/621f3eff1f400000.png", // ../assets/02左手/zuo1.png
  "https://face-image.sduonline.cn/621f3eff23800000.png", // ../assets/02左手/zuo2.png
  "https://face-image.sduonline.cn/621f3eff1f800000.png", // ../assets/02左手/zuo3.png
  "https://face-image.sduonline.cn/621f3eff23c00000.png", // ../assets/02左手/zuo4.png
  "https://face-image.sduonline.cn/621f3eff23000000.png", // ../assets/02左手/zuo5.png
];
const bigLeftHand = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/222347/4/29252/1904/647a1ba6F3c426059/f270b0210b072ba1.jpg", // ../assets/缩略图/02左手/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/95062/28/39673/1866/647a1ba6F09a4ac29/627ed50b989ba379.jpg", // ../assets/缩略图/02左手/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/143665/10/38222/5370/647a1ba6F96f1b205/64ba33877f2c4287.jpg", // ../assets/缩略图/02左手/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/134705/12/33690/5543/647a1ba6F6b1f775d/0e81bc8e0e2884c6.jpg", // ../assets/缩略图/02左手/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/177199/23/36748/2574/647a1ba6F95b41a3d/cb26fd0eee0bb611.jpg", // ../assets/缩略图/02左手/5.png
];
const hat = [
  "https://face-image.sduonline.cn/621f3f0073000000.png", // ../assets/03文学学士帽/xueshimao.png
];
const bighat = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/145209/19/38528/18753/647a1ba6F33375e3f/4cb2bc2a2acfae13.jpg", // ../assets/缩略图/03学士帽/1.png
];
const earshi = [
  "https://face-image.sduonline.cn/621f3f00fd800000.png", // ../assets/04耳饰/ershi1.png
  "https://face-image.sduonline.cn/621f3f00fe800002.png", // ../assets/04耳饰/ershi2.png
  "https://face-image.sduonline.cn/621f3f00fe800001.png", // ../assets/04耳饰/ershi3.png
  "https://face-image.sduonline.cn/621f3f00fdc00000.png", // ../assets/04耳饰/ershi4.png
  "https://face-image.sduonline.cn/621f3f00fe000000.png", // ../assets/04耳饰/ershi5.png
  "https://face-image.sduonline.cn/621f3f00fe000001.png", // ../assets/04耳饰/ershi6.png
  "https://face-image.sduonline.cn/621f3f00fe800000.png", // ../assets/04耳饰/ershi7.png
];
const bigearshi = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/100436/13/24339/1570/647a1ba7F2f3b6437/837d386a07475286.jpg", // ../assets/缩略图/04耳饰/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/144831/8/36469/1820/647a1ba7Fb4027c10/d7016d2ffcd1c35c.jpg", // ../assets/缩略图/04耳饰/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/94744/20/39021/1261/647a1ba7F7ced0536/ef155dd8715246c9.jpg", // ../assets/缩略图/04耳饰/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/113108/36/36668/1588/647a1ba7F3899d77b/98fb802607adf5b8.jpg", // ../assets/缩略图/04耳饰/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/91505/19/23425/926/647a1ba7F3212e17c/695c87eeabd65783.jpg", // ../assets/缩略图/04耳饰/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/96046/36/39163/1279/647a1ba7Fb343560d/ad69ce05597d8ebe.jpg", // ../assets/缩略图/04耳饰/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/95646/39/39609/1367/647a1ba7F87cdd51f/f816522b064b9020.jpg", // ../assets/缩略图/04耳饰/7.png
];
const faqia = [
  "https://face-image.sduonline.cn/621f3f01fc800000.png", // ../assets/05发卡/ka1.png
  "https://face-image.sduonline.cn/621f3f01ff400000.png", // ../assets/05发卡/ka2.png
  "https://face-image.sduonline.cn/621f3f01ffc00000.png", // ../assets/05发卡/ka3.png
  "https://face-image.sduonline.cn/621f3f01ff000000.png", // ../assets/05发卡/ka4.png
  "https://face-image.sduonline.cn/621f3f01ffc00001.png", // ../assets/05发卡/ka5.png
  "https://face-image.sduonline.cn/621f3f01fe800000.png", // ../assets/05发卡/ka6.png
];
const bigfaqia = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/120903/34/38189/1955/647a1ba8F5126b6bf/7928c4221d9773ff.jpg", // ../assets/缩略图/05发卡/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/166134/22/34681/1658/647a1ba8F2a21309d/b5c534c6a5aca824.jpg", // ../assets/缩略图/05发卡/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/221745/2/27212/1817/647a1ba8F95900248/e152a81d30219ea2.jpg", // ../assets/缩略图/05发卡/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/118168/19/35265/1363/647a1ba8F4b17b8dc/30ea3d98c98dbdf3.jpg", // ../assets/缩略图/05发卡/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/98171/16/40185/1305/647a1ba8F09126e32/4b27408a27d0e52e.jpg", // ../assets/缩略图/05发卡/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/99961/21/38379/1374/647a1ba8Fe8dcd3ec/605c210c4a66fd3e.jpg", // ../assets/缩略图/05发卡/6.png
];
const glass = [
  "https://face-image.sduonline.cn/621f3f02b0c00000.png", // ../assets/06眼镜/jing1.png
  "https://face-image.sduonline.cn/621f3f02b1000000.png", // ../assets/06眼镜/jing2.png
  "https://face-image.sduonline.cn/621f3f02b3000000.png", // ../assets/06眼镜/jing3.png
  "https://face-image.sduonline.cn/621f3f02b3000001.png", // ../assets/06眼镜/jing4.png
  //"https://face-image.sduonline.cn/621f3f02b1c00000.png", // ../assets/06眼镜/jing5.png
];
const bigglass = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/145580/40/32266/2354/647a1ba9F40a26916/6ae6071d5eefd949.jpg", // ../assets/缩略图/06眼镜/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/212372/22/31839/2972/647a1ba9F09d3b5be/f3ef84d87bb50d13.jpg", // ../assets/缩略图/06眼镜/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/119213/7/38959/2642/647a1ba9Fb0a67013/073e92641bb9a340.jpg", // ../assets/缩略图/06眼镜/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/67532/34/25488/2397/647a1ba9Fd19e94dc/27acd8acbdedc1d8.jpg", // ../assets/缩略图/06眼镜/4.png
 // "https://img13.360buyimg.com/ddimg/jfs/t1/113612/13/36753/2699/647a1ba9Fc991d591/3ff1d7bd4afd812e.jpg", // ../assets/缩略图/06眼镜/5.png
];
const liuhai = [
  "https://face-image.sduonline.cn/621f3f038b400001.png", // ../assets/07刘海/liuhai1.png
  "https://face-image.sduonline.cn/621f3f038a800000.png", // ../assets/07刘海/liuhai2.png
  "https://face-image.sduonline.cn/621f3f0388c00000.png", // ../assets/07刘海/liuhai3.png
  "https://face-image.sduonline.cn/621f3f038b000000.png", // ../assets/07刘海/liuhai4.png
  "https://face-image.sduonline.cn/621f3f038b400000.png", // ../assets/07刘海/liuhai5.png
];
const bigliuhai = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/102364/4/26075/6056/647a1baaF393a835c/a94c85683305a1c1.jpg", // ../assets/缩略图/07刘海/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/123191/23/38014/6434/647a1baaF97befa01/25a96efe8ad5fac6.jpg", // ../assets/缩略图/07刘海/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/137734/27/37207/6277/647a0a47Fb6d478fa/2242d9bcbd4220d6.jpg", // ../assets/缩略图/07刘海/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/97190/22/38638/6007/647a1baaFbd835e45/53a4964a8c875fcc.jpg", // ../assets/缩略图/07刘海/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/149474/30/33385/6163/647a1baaF0be9764b/7d5f1884bf33663b.jpg", // ../assets/缩略图/07刘海/5.png
];
const meimao = [
  "https://face-image.sduonline.cn/621f3f0443800000.png", // ../assets/08眉毛/meimao1.png
  "https://face-image.sduonline.cn/621f3f0446800000.png", // ../assets/08眉毛/meimao2.png
  "https://face-image.sduonline.cn/621f3f0446800001.png", // ../assets/08眉毛/meimao3.png
  "https://face-image.sduonline.cn/621f3f0443c00001.png", // ../assets/08眉毛/meimao4.png
  "https://face-image.sduonline.cn/621f3f0446800002.png", // ../assets/08眉毛/meimao5.png
  "https://face-image.sduonline.cn/621f3f0443c00000.png", // ../assets/08眉毛/meimao6.png
  "https://face-image.sduonline.cn/621f3f0446400000.png", // ../assets/08眉毛/meimao7.png
  "https://face-image.sduonline.cn/621f3f0444000000.png", // ../assets/08眉毛/meimao8.png
];
const bigmeimao = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/18274/5/21169/1108/647a1babF6cb12668/a57eaa086a076460.jpg", // ../assets/缩略图/08眉毛/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/116896/31/37331/1352/647a1babFf5dc949e/02cc32aebe150a61.jpg", // ../assets/缩略图/08眉毛/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/219576/27/22231/1832/647a1babFf1b20650/e2dd400fdc84e457.jpg", // ../assets/缩略图/08眉毛/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/105940/37/41777/1184/647a1babFf7edddbb/a8281aba6555257d.jpg", // ../assets/缩略图/08眉毛/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/41257/4/23839/1317/647a1babF2704b095/81c2485565014b11.jpg", // ../assets/缩略图/08眉毛/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/67054/32/22225/1281/647a1babF1d4c913d/c4ac99ccb61d0d06.jpg", // ../assets/缩略图/08眉毛/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/122573/22/39798/1200/647a1babFcc336c00/8604939fa811427b.jpg", // ../assets/缩略图/08眉毛/7.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/140890/37/32841/1164/647a1babFce96cb33/233c20e38ef8ceba.jpg", // ../assets/缩略图/08眉毛/8.png
];
const zuiba = [
  "https://face-image.sduonline.cn/621f3f0595000000.png", // ../assets/09嘴巴/zuiba01.png
  "https://face-image.sduonline.cn/621f3f0595400006.png", // ../assets/09嘴巴/zuiba02.png
  "https://face-image.sduonline.cn/621f3f0595000001.png", // ../assets/09嘴巴/zuiba03.png
  "https://face-image.sduonline.cn/621f3f0594c00000.png", // ../assets/09嘴巴/zuiba04.png
  "https://face-image.sduonline.cn/621f3f0596800000.png", // ../assets/09嘴巴/zuiba05.png
  "https://face-image.sduonline.cn/621f3f0595400000.png", // ../assets/09嘴巴/zuiba06.png
  "https://face-image.sduonline.cn/621f3f0595400002.png", // ../assets/09嘴巴/zuiba07.png
  "https://face-image.sduonline.cn/621f3f0595400003.png", // ../assets/09嘴巴/zuiba08.png
  "https://face-image.sduonline.cn/621f3f0595400001.png", // ../assets/09嘴巴/zuiba09.png
  "https://face-image.sduonline.cn/621f3f0595400004.png", // ../assets/09嘴巴/zuiba10.png
  "https://face-image.sduonline.cn/621f3f0595c00002.png", // ../assets/09嘴巴/zuiba11.png
  "https://face-image.sduonline.cn/621f3f0595c00000.png", // ../assets/09嘴巴/zuiba12.png
  "https://face-image.sduonline.cn/621f3f0595400005.png", // ../assets/09嘴巴/zuiba13.png
  "https://face-image.sduonline.cn/621f3f0595c00006.png", // ../assets/09嘴巴/zuiba14.png
  "https://face-image.sduonline.cn/621f3f0595c00001.png", // ../assets/09嘴巴/zuiba15.png
  "https://face-image.sduonline.cn/621f3f0595c00007.png", // ../assets/09嘴巴/zuiba16.png
  "https://face-image.sduonline.cn/621f3f0595c00005.png", // ../assets/09嘴巴/zuiba17.png
  "https://face-image.sduonline.cn/621f3f0596400000.png", // ../assets/09嘴巴/zuiba18.png
  "https://face-image.sduonline.cn/621f3f0596000000.png", // ../assets/09嘴巴/zuiba19.png
  "https://face-image.sduonline.cn/621f3f0595c00003.png", // ../assets/09嘴巴/zuiba20.png
  "https://face-image.sduonline.cn/621f3f0595c00004.png", // ../assets/09嘴巴/zuiba21.png
];
const bigzuiba = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/96915/20/41061/1654/647a1badFac4817f6/6488308a55a71d6d.jpg", // ../assets/缩略图/09嘴巴/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/88382/4/35167/1182/647a1badF801b9016/b649a9fc657fdd46.jpg", // ../assets/缩略图/09嘴巴/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/217533/23/27640/1954/647a1badFe256b1f0/c64f0cc27df66115.jpg", // ../assets/缩略图/09嘴巴/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/97164/17/41779/1149/647a0a48F18a8b290/ad29309f119fda52.jpg", // ../assets/缩略图/09嘴巴/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/90425/20/26802/1668/647a1badF43866717/93d171a359926b27.jpg", // ../assets/缩略图/09嘴巴/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/185007/1/34006/2088/647a1badF73ba2c51/1ee34f2beaef3b32.jpg", // ../assets/缩略图/09嘴巴/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/155613/28/38622/1810/647a1badFf6f7ae64/3e1353989475dd98.jpg", // ../assets/缩略图/09嘴巴/7.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/138311/6/31105/2792/647a1badF3ffb9c88/d2f962186233a900.jpg", // ../assets/缩略图/09嘴巴/8.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/116032/11/37284/2116/647a1badF96497eb4/6341cf2a869ec970.jpg", // ../assets/缩略图/09嘴巴/9.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/128248/33/33571/2409/647a1badFce141d47/9c9796c88cac5958.jpg", // ../assets/缩略图/09嘴巴/10.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/219023/19/31034/2963/647a1badF7a648ff5/3d20aedf6dc2d345.jpg", // ../assets/缩略图/09嘴巴/11.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/211860/2/28132/3364/647a1badF7c925b59/cfd89af0edb44c7b.jpg", // ../assets/缩略图/09嘴巴/12.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/139951/3/37084/1815/647a1badF63bfb2a8/0baf2e35cc02fa49.jpg", // ../assets/缩略图/09嘴巴/13.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/117022/34/33803/2459/647a1badF255d7adb/4a60b142132c88e1.jpg", // ../assets/缩略图/09嘴巴/14.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/201767/33/35878/1585/647a1badF3dd9c963/24be21d68af77087.jpg", // ../assets/缩略图/09嘴巴/15.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/110469/18/40737/1391/647a1badF33f61b3d/44b53f2fb1d7e006.jpg", // ../assets/缩略图/09嘴巴/16.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/137854/22/33128/3215/647a1badF87b25338/00422bc945fd5a1c.jpg", // ../assets/缩略图/09嘴巴/17.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/141555/35/33157/2876/647a1badF996c660c/55f9024608e7b6e8.jpg", // ../assets/缩略图/09嘴巴/18.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/91136/5/37536/3246/647a1badFb6b9a59a/3cada4dc82df163d.jpg", // ../assets/缩略图/09嘴巴/19.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/222123/6/28080/1412/647a1badF76d080e9/87c5a9e770359077.jpg", // ../assets/缩略图/09嘴巴/20.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/123177/37/34679/1300/647a1badF3a3236ca/b9ba4a6a8a3058cb.jpg", // ../assets/缩略图/09嘴巴/21.png
];
const eye = [
  "https://face-image.sduonline.cn/621f3f075e800000.png", // ../assets/10眼睛/A闭眼/1.png
  "https://face-image.sduonline.cn/621f3f0762000000.png", // ../assets/10眼睛/A闭眼/2.png
  "https://face-image.sduonline.cn/621f3f075fc00000.png", // ../assets/10眼睛/A闭眼/3.png
  "https://face-image.sduonline.cn/621f3f0762400001.png", // ../assets/10眼睛/B特殊表情/1.png
  "https://face-image.sduonline.cn/621f3f075fc00001.png", // ../assets/10眼睛/B特殊表情/2.png
  "https://face-image.sduonline.cn/621f3f0762400006.png", // ../assets/10眼睛/B特殊表情/3.png
  "https://face-image.sduonline.cn/621f3f0762400002.png", // ../assets/10眼睛/B特殊表情/4.png
  "https://face-image.sduonline.cn/621f3f075f800000.png", // ../assets/10眼睛/B特殊表情/5.png
  "https://face-image.sduonline.cn/621f3f0762000001.png", // ../assets/10眼睛/B特殊表情/6.png
  "https://face-image.sduonline.cn/621f3f0762000003.png", // ../assets/10眼睛/C单眼皮/1.png
  "https://face-image.sduonline.cn/621f3f0762000016.png", // ../assets/10眼睛/C单眼皮/2.png
  "https://face-image.sduonline.cn/621f3f0762000002.png", // ../assets/10眼睛/C单眼皮/3.png
  "https://face-image.sduonline.cn/621f3f0762400004.png", // ../assets/10眼睛/C单眼皮/4.png
  "https://face-image.sduonline.cn/621f3f076200000e.png", // ../assets/10眼睛/C单眼皮/5.png
  "https://face-image.sduonline.cn/621f3f0762000004.png", // ../assets/10眼睛/C单眼皮/6.png
  "https://face-image.sduonline.cn/621f3f0762000005.png", // ../assets/10眼睛/C单眼皮/7.png
  "https://face-image.sduonline.cn/621f3f0762000006.png", // ../assets/10眼睛/C单眼皮/8.png
  "https://face-image.sduonline.cn/621f3f0762000007.png", // ../assets/10眼睛/C单眼皮/9.png
  "https://face-image.sduonline.cn/621f3f0762000008.png", // ../assets/10眼睛/C单眼皮/10.png
  "https://face-image.sduonline.cn/621f3f0762000009.png", // ../assets/10眼睛/C单眼皮/11.png
  "https://face-image.sduonline.cn/621f3f0762400000.png", // ../assets/10眼睛/C单眼皮/12.png
  "https://face-image.sduonline.cn/621f3f076200000a.png", // ../assets/10眼睛/D双眼皮/1.png
  "https://face-image.sduonline.cn/621f3f076200000b.png", // ../assets/10眼睛/D双眼皮/2.png
  "https://face-image.sduonline.cn/621f3f076200000c.png", // ../assets/10眼睛/D双眼皮/3.png
  "https://face-image.sduonline.cn/621f3f076200000d.png", // ../assets/10眼睛/D双眼皮/4.png
  "https://face-image.sduonline.cn/621f3f0762400003.png", // ../assets/10眼睛/D双眼皮/5.png
  "https://face-image.sduonline.cn/621f3f076200000f.png", // ../assets/10眼睛/D双眼皮/6.png
  "https://face-image.sduonline.cn/621f3f0762000010.png", // ../assets/10眼睛/D双眼皮/7.png
  "https://face-image.sduonline.cn/621f3f0762000011.png", // ../assets/10眼睛/D双眼皮/8.png
  "https://face-image.sduonline.cn/621f3f0762000012.png", // ../assets/10眼睛/D双眼皮/9.png
  "https://face-image.sduonline.cn/621f3f0762000013.png", // ../assets/10眼睛/D双眼皮/10.png
  "https://face-image.sduonline.cn/621f3f0762000014.png", // ../assets/10眼睛/D双眼皮/11.png
  "https://face-image.sduonline.cn/621f3f0762000015.png", // ../assets/10眼睛/D双眼皮/12.png
  "https://face-image.sduonline.cn/621f3f0762400005.png", // ../assets/10眼睛/D双眼皮/13.png
];
const bigeye = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/122371/17/34601/2105/647a1bb0F2d2418e1/19590d00094c8217.jpg", // ../assets/缩略图/10眼睛/A闭眼/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/134633/8/34044/1683/647a1bb0Fdd29bdbb/923f215908d31982.jpg", // ../assets/缩略图/10眼睛/A闭眼/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/91327/13/41585/1651/647a1bb0F87347ab2/316150a404a21344.jpg", // ../assets/缩略图/10眼睛/A闭眼/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/43742/13/23791/1597/647a1bb0F439f4254/ccf211c70282dc48.jpg", // ../assets/缩略图/10眼睛/B特殊表情/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/141951/32/37122/2044/647a1bb0F0899c4bd/09d58721912b1824.jpg", // ../assets/缩略图/10眼睛/B特殊表情/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/102023/4/24918/3277/647a1bb0Fde640f3c/df775bc5a2fa57b9.jpg", // ../assets/缩略图/10眼睛/B特殊表情/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/139265/7/37561/2649/647a1bb0Fd296225f/723b220b5a630a2a.jpg", // ../assets/缩略图/10眼睛/B特殊表情/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/66377/26/22287/1247/647a0a4bF25cf35f7/682f21348dc42182.jpg", // ../assets/缩略图/10眼睛/B特殊表情/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/105785/16/38090/1669/647a1bb0F74031c07/17cebadfdacd165b.jpg", // ../assets/缩略图/10眼睛/B特殊表情/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/132197/36/38563/4319/647a1bb0F99008370/d100c1c904ee029c.jpg", // ../assets/缩略图/10眼睛/C单眼皮/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/115776/11/38332/3714/647a1bb0Fdd495100/8c0e990c6de58bac.jpg", // ../assets/缩略图/10眼睛/C单眼皮/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/122240/7/34836/4015/647a1bb0Fcccda473/749a527c95bec840.jpg", // ../assets/缩略图/10眼睛/C单眼皮/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/130429/10/36962/1879/647a1bb0F1b706eba/f03de7c27b489c3c.jpg", // ../assets/缩略图/10眼睛/C单眼皮/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/144297/16/34767/4010/647a0a4bF4ee4333a/52dfa49fdd2b2256.jpg", // ../assets/缩略图/10眼睛/C单眼皮/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/124429/33/34137/4855/647a1bb0F7470d4c8/280f76cf28864291.jpg", // ../assets/缩略图/10眼睛/C单眼皮/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/215326/19/31298/3574/647a1bb0Ff0713ae1/4ccb3d902e9f393e.jpg", // ../assets/缩略图/10眼睛/C单眼皮/7.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/114664/19/37028/3274/647a1bb0Ff4e58197/3d23898ed86a77c6.jpg", // ../assets/缩略图/10眼睛/C单眼皮/8.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/104162/23/29241/3412/647a1bb0F534ebbbd/1b06a7b9476e7d07.jpg", // ../assets/缩略图/10眼睛/C单眼皮/9.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/88850/25/40835/3993/647a1bb0F0a870177/d6ee432bb462bc81.jpg", // ../assets/缩略图/10眼睛/C单眼皮/10.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/163586/40/26449/3500/647a1bb0Fdd1d1420/afd15890bcfbba37.jpg", // ../assets/缩略图/10眼睛/C单眼皮/11.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/102777/3/39325/3198/647a1bb0F5372a5bf/3c55a299b8de8d75.jpg", // ../assets/缩略图/10眼睛/C单眼皮/12.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/119884/3/31607/4862/647a1bb0F556b722c/cf05bb6495c1e522.jpg", // ../assets/缩略图/10眼睛/D双眼皮/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/140163/29/37879/4882/647a1bb0Ffeae500e/96ca4f668b4ba52d.jpg", // ../assets/缩略图/10眼睛/D双眼皮/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/197330/27/34791/4458/647a1bb0Ff6e4ab3a/cb6023463b26a33d.jpg", // ../assets/缩略图/10眼睛/D双眼皮/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/141533/6/37167/4425/647a1bb0Fc0c7bf5c/b88c6163348a04c1.jpg", // ../assets/缩略图/10眼睛/D双眼皮/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/204805/8/35447/2310/647a1bb0F098ba6e4/3a74ab2e3c60e1c7.jpg", // ../assets/缩略图/10眼睛/D双眼皮/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/218516/15/25391/4433/647a1bb0F7a0721a7/477855d551f39a03.jpg", // ../assets/缩略图/10眼睛/D双眼皮/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/171148/26/34502/5532/647a0a4bFe03faf72/76400263721e3ee3.jpg", // ../assets/缩略图/10眼睛/D双眼皮/7.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/93148/5/39376/3956/647a1bb0F5f7493a0/630711a8725abd3e.jpg", // ../assets/缩略图/10眼睛/D双眼皮/8.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/118094/40/36782/4195/647a1bb0Ff302c48e/b1da89d670f0b869.jpg", // ../assets/缩略图/10眼睛/D双眼皮/9.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/204786/31/35565/4006/647a1bb0F7e4bc1b8/c234936a32dfedca.jpg", // ../assets/缩略图/10眼睛/D双眼皮/10.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/91866/13/40044/4658/647a1bb0Fd3b2ebe0/3ec8f5d191ebe7c1.jpg", // ../assets/缩略图/10眼睛/D双眼皮/11.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/105738/9/40650/4094/647a1bb0F6eb50c3e/dce93a663604c468.jpg", // ../assets/缩略图/10眼睛/D双眼皮/12.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/144951/33/38441/3742/647a1bb0F497c2779/5df8d777ef6fd828.jpg", // ../assets/缩略图/10眼睛/D双眼皮/13.png
];
const saihong = [
  "https://face-image.sduonline.cn/621f3f0a5bc00000.png", // ../assets/11腮红/hong1.png
  "https://face-image.sduonline.cn/621f3f0a5b800000.png", // ../assets/11腮红/hong2.png
  "https://face-image.sduonline.cn/621f3f0a5c800003.png", // ../assets/11腮红/hong3.png
  "https://face-image.sduonline.cn/621f3f0a5c800000.png", // ../assets/11腮红/hong4.png
  "https://face-image.sduonline.cn/621f3f0a5c800001.png", // ../assets/11腮红/hong5.png
  "https://face-image.sduonline.cn/621f3f0a5c800002.png", // ../assets/11腮红/hong6.png
  "https://face-image.sduonline.cn/621f3f0a5c800004.png", // ../assets/11腮红/hong7.png
  "https://face-image.sduonline.cn/621f3f0a5d400000.png", // ../assets/11腮红/hong8.png
];
const bigsaihong = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/97230/28/27545/1669/647a1bb1F35834636/85e1864aa8c86c52.jpg", // ../assets/缩略图/11腮红/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/715/18/21966/1624/647a1bb1Fd4fb95a9/ee09f9fc42e95cf2.jpg", // ../assets/缩略图/11腮红/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/161417/40/35645/1343/647a1bb1F6e35127d/3525bb184ce87b62.jpg", // ../assets/缩略图/11腮红/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/92806/13/39472/1785/647a1bb1Ffb791c23/a45889eb144930d4.jpg", // ../assets/缩略图/11腮红/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/122028/16/37218/2178/647a1bb1F61b8eb6b/25d66d3e13ed8d02.jpg", // ../assets/缩略图/11腮红/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/126421/13/33994/2698/647a1bb1Fc92fab2e/b52ee36a491b8fb2.jpg", // ../assets/缩略图/11腮红/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/148009/5/33738/2739/647a1bb1Faa6139c8/31855a4a1497acde.jpg", // ../assets/缩略图/11腮红/7.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/109535/27/18448/2083/647a1bb1F1d00a0c9/a774defba9204c85.jpg", // ../assets/缩略图/11腮红/8.png
];
const bizi = [
  "https://face-image.sduonline.cn/621f3f0b6b800000.png", // ../assets/12鼻子/be01.png
  "https://face-image.sduonline.cn/621f3f0b6bc00000.png", // ../assets/12鼻子/be02.png
  "https://face-image.sduonline.cn/621f3f0b6bc00001.png", // ../assets/12鼻子/be03.png
  "https://face-image.sduonline.cn/621f3f0b6c400005.png", // ../assets/12鼻子/be04.png
  "https://face-image.sduonline.cn/621f3f0b6c400004.png", // ../assets/12鼻子/be05.png
  "https://face-image.sduonline.cn/621f3f0b6bc00002.png", // ../assets/12鼻子/be06.png
  "https://face-image.sduonline.cn/621f3f0b6bc00005.png", // ../assets/12鼻子/be07.png
  "https://face-image.sduonline.cn/621f3f0b6bc00003.png", // ../assets/12鼻子/be08.png
  "https://face-image.sduonline.cn/621f3f0b6bc00004.png", // ../assets/12鼻子/be09.png
  "https://face-image.sduonline.cn/621f3f0b6bc00006.png", // ../assets/12鼻子/be10.png
  "https://face-image.sduonline.cn/621f3f0b6c400000.png", // ../assets/12鼻子/be11.png
  "https://face-image.sduonline.cn/621f3f0b6bc00007.png", // ../assets/12鼻子/be12.png
  "https://face-image.sduonline.cn/621f3f0b6c400001.png", // ../assets/12鼻子/be13.png
  "https://face-image.sduonline.cn/621f3f0b6c400003.png", // ../assets/12鼻子/be14.png
  //"https://face-image.sduonline.cn/621f3f0b6c400002.png", // ../assets/12鼻子/be15.png
];
const bigbizi = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/132667/1/34344/994/647a1bb2F7b9d1944/4fd06327a595f697.jpg", // ../assets/缩略图/12鼻子/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/86334/14/25994/1429/647a1bb3Fe987a0c5/c68569d7731e2203.jpg", // ../assets/缩略图/12鼻子/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/146850/36/39321/1248/647a1bb3F9136c186/556b162b5749aa9a.jpg", // ../assets/缩略图/12鼻子/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/141613/21/37125/1219/647a1bb3F41d72826/4260c8cf4de46114.jpg", // ../assets/缩略图/12鼻子/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/89910/30/41187/1212/647a1bb3F3288b24d/f22c5ee36e5786aa.jpg", // ../assets/缩略图/12鼻子/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/122988/19/33679/1344/647a1bb3F3d0d1e67/739c124c7e69ea33.jpg", // ../assets/缩略图/12鼻子/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/113826/28/36419/1399/647a1bb3F175e479f/c6082fdf9043ac3c.jpg", // ../assets/缩略图/12鼻子/7.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/144156/16/34021/1351/647a1bb3Fd8dfefea/e33f030e2ca78b21.jpg", // ../assets/缩略图/12鼻子/8.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/211887/27/31471/1364/647a1bb3F7d610bd1/a65f429bc5bace86.jpg", // ../assets/缩略图/12鼻子/9.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/154087/17/17173/1468/647a1bb3F4f4dbf13/cf441937d211022c.jpg", // ../assets/缩略图/12鼻子/10.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/157192/21/26155/1618/647a1bb3F63f66228/d8159d613a7bd845.jpg", // ../assets/缩略图/12鼻子/11.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/99562/38/36741/1058/647a1bb3Fda79a8e3/eae71d2d82a7888c.jpg", // ../assets/缩略图/12鼻子/12.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/156188/23/37263/1427/647a1bb3F110bea80/6d6dd7999b600356.jpg", // ../assets/缩略图/12鼻子/13.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/173378/8/37740/1681/647a1bb3F529b08f0/2e2094d7c70b9d1b.jpg", // ../assets/缩略图/12鼻子/14.png
  //"https://img13.360buyimg.com/ddimg/jfs/t1/175865/26/33677/1809/647a1bb3Fd3b1e7e5/666f362665ad526c.jpg", // ../assets/缩略图/12鼻子/15.png
];
const lianxing = [
  "https://face-image.sduonline.cn/621f3f0cec000000.png", // ../assets/13脸型/lian1.png
  "https://face-image.sduonline.cn/621f3f0cef400000.png", // ../assets/13脸型/lian2.png
  "https://face-image.sduonline.cn/621f3f0cec000001.png", // ../assets/13脸型/lian3.png
  "https://face-image.sduonline.cn/621f3f0ceb800000.png", // ../assets/13脸型/lian4.png
  "https://face-image.sduonline.cn/621f3f0ceec00000.png", // ../assets/13脸型/lian5.png
];
const ear = [
  "https://face-image.sduonline.cn/621f3f0d69800000.png", // ../assets/14耳朵/er1.png
  "https://face-image.sduonline.cn/621f3f0d6a000000.png", // ../assets/14耳朵/er2.png
  "https://face-image.sduonline.cn/621f3f0d6a000001.png", // ../assets/14耳朵/er3.png
  "https://face-image.sduonline.cn/621f3f0d69800001.png", // ../assets/14耳朵/er4.png
  "https://face-image.sduonline.cn/621f3f0d6bc00000.png", // ../assets/14耳朵/er5.png
  "https://face-image.sduonline.cn/621f3f0d6a400000.png", // ../assets/14耳朵/er6.png
  "https://face-image.sduonline.cn/621f3f0d6a400001.png", // ../assets/14耳朵/er7.png
];
const bigear = [
  "https://img13.360buyimg.com/ddimg/jfs/t1/48058/13/24062/1835/647a1bb4F00ba5154/0bf59a5f4907bff5.jpg", // ../assets/缩略图/14耳朵/1.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/123690/6/35792/2001/647a1bb4F4a71df47/1985b498b476aa2f.jpg", // ../assets/缩略图/14耳朵/2.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/68185/7/24759/1927/647a1bb4Faca5848d/60b9035143871bbd.jpg", // ../assets/缩略图/14耳朵/3.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/118389/12/37947/2069/647a1bb4Fd1e761fb/708ccf387b98593e.jpg", // ../assets/缩略图/14耳朵/4.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/120114/32/35835/2122/647a1bb4F6a439fb7/ec8aa37fcefc8c05.jpg", // ../assets/缩略图/14耳朵/5.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/139143/10/37066/1967/647a1bb4F5d5b6ad4/f4e21d169b6006ab.jpg", // ../assets/缩略图/14耳朵/6.png
  "https://img13.360buyimg.com/ddimg/jfs/t1/123692/18/36252/2066/647a1bb4F24be427e/aff15b2833c63ac6.jpg", // ../assets/缩略图/14耳朵/7.png
];
const neichenyiling = [
  "https://face-image.sduonline.cn/621f3f0e62c00000.png", // ../assets/15内衬衣领/nei1.png
  "https://face-image.sduonline.cn/621f3f0e63400000.png", // ../assets/15内衬衣领/nei2.png
  "https://face-image.sduonline.cn/621f3f0e64400000.png", // ../assets/15内衬衣领/nei3.png
  "https://face-image.sduonline.cn/621f3f0e63800000.png", // ../assets/15内衬衣领/nei4.png
  "https://face-image.sduonline.cn/621f3f0e62c00001.png", // ../assets/15内衬衣领/nei5.png
];
const xueshufu = [
  "https://face-image.sduonline.cn/621f3f0ee3800000.png", // ../assets/16学术服/junshi.png
  "https://face-image.sduonline.cn/621f3f0ee4800000.png", // ../assets/16学术服/nongxue.png
  "https://face-image.sduonline.cn/621f3f0ee4000000.png", // ../assets/16学术服//yixue.png
  "https://face-image.sduonline.cn/621f3f0ee5000000.png", // ../assets/16学术服/gongxue.png
  "https://face-image.sduonline.cn/621f3f0ee3800001.png", // ../assets/16学术服/wenxue.png
  "https://face-image.sduonline.cn/621f3f0ee4800001.png", // ../assets/16学术服/lixue.png
];
const hair = [
  "https://face-image.sduonline.cn/621f3f0f50c00000.png", // ../assets/17后边头发/fa1.png
  "https://face-image.sduonline.cn/621f3f0f51c00003.png", // ../assets/17后边头发/fa2.png
  "https://face-image.sduonline.cn/621f3f0f53400001.png", // ../assets/17后边头发/fa3.png
  "https://face-image.sduonline.cn/621f3f0f53400000.png", // ../assets/17后边头发/fa4.png
  "https://face-image.sduonline.cn/621f3f0f51000000.png", // ../assets/17后边头发/fa5.png
  "https://face-image.sduonline.cn/621f3f0f51400000.png", // ../assets/17后边头发/fa6.png
  "https://face-image.sduonline.cn/621f3f0f51400001.png", // ../assets/17后边头发/fa7.png
  "https://face-image.sduonline.cn/621f3f0f51c00001.png", // ../assets/17后边头发/fa8.png
  "https://face-image.sduonline.cn/621f3f0f51400002.png", // ../assets/17后边头发/fa9.png
  "https://face-image.sduonline.cn/621f3f0f51400003.png", // ../assets/17后边头发/fa10.png
  "https://face-image.sduonline.cn/621f3f0f51400004.png", // ../assets/17后边头发/fa11.png
  "https://face-image.sduonline.cn/621f3f0f51c00000.png", // ../assets/17后边头发/fa12.png
  "https://face-image.sduonline.cn/621f3f0f51c00002.png", // ../assets/17后边头发/fa13.png
];
const bg = [
  "https://face-image.sduonline.cn/621f3f105c000000.png", // ../assets/18背景/A纯色背景/001.png
  "https://face-image.sduonline.cn/621f3f105a400000.png", // ../assets/18背景/A纯色背景/002.png
  "https://face-image.sduonline.cn/621f3f105ac00005.png", // ../assets/18背景/A纯色背景/003.png
  "https://face-image.sduonline.cn/621f3f105ac00006.png", // ../assets/18背景/A纯色背景/004.png
  "https://face-image.sduonline.cn/621f3f105d400001.png", // ../assets/18背景/A纯色背景/005.png
  "https://face-image.sduonline.cn/621f3f105d000000.png", // ../assets/18背景/A纯色背景/006.png
  "https://face-image.sduonline.cn/621f3f105d400000.png", // ../assets/18背景/A纯色背景/007.png
  "https://face-image.sduonline.cn/621f3f105a400001.png", // ../assets/18背景/A纯色背景/008.png
  "https://face-image.sduonline.cn/621f3f105a800000.png", // ../assets/18背景/A纯色背景/009.png
  "https://face-image.sduonline.cn/621f3f105ac00000.png", // ../assets/18背景/A纯色背景/010.png
  "https://face-image.sduonline.cn/621f3f105ac00001.png", // ../assets/18背景/A纯色背景/011.png
  "https://face-image.sduonline.cn/621f3f105ac00002.png", // ../assets/18背景/A纯色背景/012.png
  "https://face-image.sduonline.cn/621f3f105ac00003.png", // ../assets/18背景/A纯色背景/013.png
  "https://face-image.sduonline.cn/621f3f105ac00004.png", // ../assets/18背景/B校区背景/zhongxin.png
  "https://face-image.sduonline.cn/621f3f105c000002.png", // ../assets/18背景/B校区背景/xinglongshan.png
  "https://face-image.sduonline.cn/621f3f105ac00007.png", // ../assets/18背景/B校区背景/qianfoushan.png
  "https://face-image.sduonline.cn/621f3f105ac00008.png", // ../assets/18背景/B校区背景/weihai.png
  "https://face-image.sduonline.cn/621f3f105ac00009.png", // ../assets/18背景/B校区背景/hongjialou.png
  "https://face-image.sduonline.cn/621f3f105ac0000a.png", // ../assets/18背景/B校区背景/baotuquan.png
  "https://face-image.sduonline.cn/621f3f105ac0000b.png", // ../assets/18背景/B校区背景/ruanjianyuan.png
  "https://face-image.sduonline.cn/621f3f105c000001.png", // ../assets/18背景/B校区背景/qingdao.png
];

export const imageUrl = [
  rightHand,
  leftHand,
  hat,
  earshi,
  faqia,
  glass,
  liuhai,
  meimao,
  zuiba,
  eye,
  saihong,
  bizi,
  lianxing,
  ear,
  neichenyiling,
  xueshufu,
  hair,
  bg,
];
export const bigimgUrl = [
  bigRightHand,
  bigLeftHand,
  bighat,
  bigearshi,
  bigfaqia,
  bigglass,
  bigliuhai,
  bigmeimao,
  bigzuiba,
  bigeye,
  bigsaihong,
  bigbizi,
  lianxing,
  bigear,
  neichenyiling,
  xueshufu,
  hair,
  bg,
];
export const imageName = [
  "右手",
  "左手",
  "学士帽",
  "耳饰",
  "发卡",
  "眼镜",
  "刘海",
  "眉毛",
  "嘴巴",
  "眼睛",
  "腮红",
  "鼻子",
  "脸型",
  "耳朵",
  "内衬衣领",
  "学士服",
  "头发",
  "背景",
];
